
import {
  PropType,
  defineProps,
  defineEmits,
  watch,
  onMounted,
  computed,
  defineComponent
} from 'vue';
import { PreviewOutcome } from '../../../../../types/sport';
import icon from '@/components/IllinoisSport/components/icons.vue';
import { GenericOption } from '../../../../../types/components';
import SpreadSelector from './SpreadSelector.vue';
import store from '@/store';

export default defineComponent({
  name: 'OddsOutcomesColumns',
  components: {
    icon,
    SpreadSelector
  },
  props: {
    outcomesColumns: {
      type: Array as PropType<PreviewOutcome[][]>,
      required: true
    },
    spreadOptions: {
      type: Array as PropType<GenericOption[]>,
      required: false
    },
    selectedSpread: {
      type: Object as PropType<GenericOption>,
      required: false,
      default: null
    },
    showOutcomesName: {
      type: Boolean,
      required: false,
      default: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSeparators: {
      type: Boolean,
      required: false,
      default: false
    },
    hideColumnSeparators: {
      type: Boolean,
      required: false,
      default: false
    },
    scrollLeft: {
      type: Number,
      required: false,
      default: 0
    }
  },
  methods: {
    addOddToCart(outcome: PreviewOutcome) {
      console.log('event.odd outcome', outcome);
      this.$emit('add-odd-to-cart', {
        outcomeUniqueId: outcome.unique_id,
        outcomeId: outcome.outcome_id,
        outcome: outcome, // Passa anche l'outcome completo per poter accedere a proprietà custom come marketId,
        marketId: outcome?.marketId
      });
    },
    emit(event: string, ...args: any[]) {
      this.$emit(event, ...args);
    },
    skeletonRowsForColumn(_colIndex: number) {
      const rows = (this.outcomesColumns?.[0]?.length as number) || 3;
      return Array(rows).fill({});
    },
    linePlaceholder(): number {
      const num = Math.random() * 2;
      return Number(num.toFixed(2));
    },
    removeParentheses(value: string): string {
      if (!value) return '';
      return value.replace(/\([^)]*\)/g, '');
    },
    isOutcomeUpdated(uniqueId: string): boolean {
      return this.$store.getters['IllinoisSport/isOutcomeRecentlyUpdated'](
        uniqueId
      );
    }
  },
  computed: {
    oddsSources() {
      return this.$store.getters['cart/getOddsSources'];
    },
    skeletonColumns(): number[] {
      const count = (this.outcomesColumns && this.outcomesColumns.length) || 3;
      return Array(count).fill(0);
    },
    debugMode(): boolean {
      console.log('DEBUG_MODE', process.env.VUE_APP_DEBUG_MODE);
      return process.env.VUE_APP_DEBUG_MODE === 'true';
    }
  },
  mounted() {
    // mounted hook
  },
  watch: {
    outcomesColumns: {
      handler(newVal) {
        // watcher
      },
      deep: true
    },
    scrollLeft(newVal: number) {
      const container = this.$refs.columnsContainer as HTMLElement;
      if (container && this.spreadOptions && this.outcomesColumns.length > 3) {
        container.scrollLeft = newVal;
      }
    }
  }
});
